(function () {
	'use strict';

	function init($) {
		function getDuration($root) {
			if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				return 0;
			}
			var raw = $root.attr('data-pull-down-duration');
			var n = parseInt(raw, 10);
			return isNaN(n) ? 400 : n;
		}

		function setPanelHidden($panel, hidden) {
			if (hidden) {
				$panel.attr('hidden', 'hidden');
			} else {
				$panel.removeAttr('hidden');
			}
		}

		$(function () {
			$('.js-product-pull-down').each(function () {
				var $root = $(this);
				var $panel = $root.find('> .product-pull-down__panel');
				if (!$panel.length) return;

				if ($root.hasClass('is-open')) {
					$panel.show();
					setPanelHidden($panel, false);
				} else {
					$panel.hide();
					setPanelHidden($panel, true);
				}
			});

			$(document).on('click', '.js-product-pull-down > .product-pull-down__summary', function (e) {
				e.preventDefault();
				var $btn = $(this);
				var $root = $btn.closest('.js-product-pull-down');
				var $panel = $root.find('> .product-pull-down__panel');
				if (!$panel.length) return;

				var duration = getDuration($root);
				var opening = !$root.hasClass('is-open');

				if (opening) {
					$root.addClass('is-open');
					$btn.attr('aria-expanded', 'true');
					setPanelHidden($panel, false);
					if (duration > 0) {
						$panel.stop(true, true).hide().slideDown(duration);
					} else {
						$panel.stop(true, true).show();
					}
				} else {
					if (duration > 0) {
						$panel.stop(true, true).slideUp(duration, function () {
							$root.removeClass('is-open');
							$btn.attr('aria-expanded', 'false');
							setPanelHidden($panel, true);
						});
					} else {
						$panel.hide();
						$root.removeClass('is-open');
						$btn.attr('aria-expanded', 'false');
						setPanelHidden($panel, true);
					}
				}
			});
		});
	}

	if (typeof window.jQuery !== 'undefined') {
		init(window.jQuery);
	}
})();
